const tableScroll = () => {
  const tables = document.querySelectorAll('.js-table-block');

  if (tables.length === 0) return;

  tables.forEach(table => {
    const icon = table.querySelector('.c-table-block__icon');

    if (!icon) return;

    table.addEventListener('touchstart', () => {
      icon.style.opacity = 0;
    });

    table.addEventListener('touchend', () => {
      setTimeout(() => {
        icon.style.opacity = 1;
      }, 1000);
    });
  });

};

const init = () => {
  tableScroll();
};

export default init;
